// extracted by mini-css-extract-plugin
export var measureBox = "_redotech-redo-web-lib-common-text-measure-box-measure-box";